import { Navbar } from "flowbite-react";
import logo from '../../resources/arsinoeVRlogo.png'
import './index.css'
import { Link } from 'react-router-dom';

export function CustomNavbar() {
  return (
    <Navbar fluid rounded className='bg-[#1F2937] text-white'>
      <Navbar.Brand as={Link} to="/">
        <img src={logo} className="mr-3 h-6 sm:h-9" alt="Flowbite React Logo" />
      </Navbar.Brand>
      <Navbar.Toggle />
      <Navbar.Collapse >
        <Navbar.Link as={Link} to="/" active className="nav-link">Home</Navbar.Link>
        <Navbar.Link as={Link} to="/dialog" className="nav-link">Dialog</Navbar.Link>
        <Navbar.Link as={Link} to="/video" className="nav-link">Videos</Navbar.Link>
        <Navbar.Link as={Link} to="/about" className="nav-link">About</Navbar.Link>
      </Navbar.Collapse>
    </Navbar>
  );
}
